module.exports = __webpack_public_path__ + "static/work8-3beac112ea1d71f9f4be5127756bdb85.jpg";